import { render, staticRenderFns } from "./ImpBusDetailPop.vue?vue&type=template&id=2dbb37c9"
import script from "./ImpBusDetailPop.vue?vue&type=script&lang=js"
export * from "./ImpBusDetailPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dbb37c9')) {
      api.createRecord('2dbb37c9', component.options)
    } else {
      api.reload('2dbb37c9', component.options)
    }
    module.hot.accept("./ImpBusDetailPop.vue?vue&type=template&id=2dbb37c9", function () {
      api.rerender('2dbb37c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/popup/ImpBusDetailPop.vue"
export default component.exports